import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from '../Common';
import { Button } from '../Common/Button';
import { createUseStyles } from 'react-jss';
import backgroundImage from '../../assets/images/main_menu.png';

export interface IMainMenuProps {
    onShowLevelSelection(): void;
    onShowCredits(): void;
    onShowSettings(): void;
}

const useStyles = createUseStyles({
    root: {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    block: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        left: '55%',
        top: '45%',
    },
});

export const MainMenu: React.FunctionComponent<IMainMenuProps> = props => {
    const styles = useStyles();

    const { t } = useTranslation();
    return (
        <div className={styles.root}>
            <div className={styles.block}>
                <h1><Title>{t('title')}</Title></h1>
                <Button onClick={props.onShowLevelSelection}>{t('mainMenu.play')}</Button>
                <Button onClick={props.onShowSettings}>{t('mainMenu.settings')}</Button>
                <Button onClick={() => alert('wo will man hin?')}>Ausfahrt</Button>
            </div>
        </div>
    );
};
